import { render, staticRenderFns } from "./Advertenties.vue?vue&type=template&id=a7d3f0dc&scoped=true&"
import script from "./Advertenties.vue?vue&type=script&lang=js&"
export * from "./Advertenties.vue?vue&type=script&lang=js&"
import style0 from "./Advertenties.vue?vue&type=style&index=0&id=a7d3f0dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d3f0dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardSubtitle,VDatePicker,VDialog,VSimpleTable,VSpacer})
